import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentBlockContainerComponent } from './containers/content-block-container/content-block-container.component';
import { ContentBlockDefaultComponent } from './components/content-block-default/content-block-default.component';
import { ContentBlockFullwidthComponent } from './components/content-block-fullwidth/content-block-fullwidth.component';
import { ContentBlocklogosComponent } from './components/content-block-logos/content-block-logos.component';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@teamfoster/pipes';
import { CoreModule } from '../core/core.module';
import { DictionaryNgrxModule } from '@teamfoster/dictionary-ngrx';
import { ContentBlockTipsComponent } from './components/content-block-tips/content-block-tips.component';
import { ContentBlockStepsComponent } from './components/content-block-steps/content-block-steps.component';
import { ContentBlockRteComponent } from './components/content-block-rte/content-block-rte.component';
import { CookieNgrxModule } from '@teamfoster/cookie-ngrx';

@NgModule({
  declarations: [
    ContentBlockContainerComponent,
    ContentBlockDefaultComponent,
    ContentBlockFullwidthComponent,
    ContentBlocklogosComponent,
    ContentBlockTipsComponent,
    ContentBlockStepsComponent,
    ContentBlockRteComponent,
  ],
  imports: [CommonModule, RouterModule, PipesModule, CoreModule, DictionaryNgrxModule, CookieNgrxModule],
  exports: [ContentBlockContainerComponent],
})
export class ContentBlocksModule {}
